// extracted by mini-css-extract-plugin
export var container = "styles-module--container--51348";
export var image = "styles-module--image--91e24";
export var imageAndTitles = "styles-module--imageAndTitles--9adbc";
export var position = "styles-module--position--e056e";
export var textContent = "styles-module--textContent--08eee";